 
import ConstantMessage from "./ConstantMessage";

export default class SessionHelper {
  static GetSessionEmployer() {
    throw new Error("Method not implemented.");
  }

  public static SetSession(AdminUser: object) {
    localStorage.setItem('User', JSON.stringify(AdminUser))
  }
  public static GetSession(): any {
    var item = localStorage.getItem('User');
    if (!item) {
      return item as unknown as any;
    }

    return JSON.parse(item) as any;
  }

  public static Logout(props: any) {
    //var user = SessionHelper.GetSession();
    //var employee= SessionHelper.GetSessionEmployer();

    SessionHelper.SetSession(null as unknown as any);
    //SessionHelper.SetSessionEmployer(null as unknown as EmployerLogin);

    // var path=  UrlPath.OrgLogin;
    // if(user){
    //     path= UrlPath.PayrollLigin
    // }
    //debugger
    props.history.push(ConstantMessage.LoginPagePath)
  }
}